import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { createInstance } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { currentLang } from '../../utils/lang';
import LegacyApp, { currentView } from './LegacyApp';
import { canStartOnePageCheckout } from './utils/eligibility';
import parseConfig from './utils/parseConfig';
const hasTranslationOriginQuery = new URLSearchParams(window.location.search).get('show-trans-origin') === 'true';
const i18n = createInstance();
i18n.use({
    type: 'postProcessor',
    name: 'addTranslationDebugPrefix',
    process: (value) => (hasTranslationOriginQuery ? `t:${value}` : value),
});
i18n.init({
    resources: {
        en: { translation: require('@/translations/one_page_checkout.en.json') },
        lv: { translation: require('@/translations/one_page_checkout.lv.json') },
        ru: { translation: require('@/translations/one_page_checkout.ru.json') },
    },
    lng: currentLang(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
        prefix: '%',
        suffix: '%',
    },
    postProcess: ['addTranslationDebugPrefix'],
});
export default function app() {
    const mount = document.querySelector('.js__one-page-checkout');
    if (!mount)
        return;
    const config = parseConfig(mount.dataset.config);
    if (!config) {
        console.error('One Page Checkout configuration is invalid');
        return;
    }
    const root = createRoot(mount);
    window.onePageCheckout = {
        canStart: variantCode => canStartOnePageCheckout(config.setting, variantCode, currentView(), new URLSearchParams(window.location.search).get('onepage'), document.body.classList.contains('ab-onepage-test')),
        start: variantCode => window.dispatchEvent(new CustomEvent('one-page-checkout:start', { detail: variantCode })),
    };
    window.dispatchEvent(new Event('one-page-checkout:ready'));
    root.render(_jsx(I18nextProvider, { i18n: i18n, children: _jsx(LegacyApp, { config: config }) }));
}
